
import React from 'react'

const CartItems = ({item, index, handleRemoveFromCart, increaseNoSeat, decreaseNoSeats}) => {
  return (
    <div className="bg-gradient-to-r from-white to-gray-50 rounded-[20px] p-6 border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 hover:border-[#B02526]/20">
      <div className='flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6'>
        
        {/* Class Info Section */}
        <div className="flex-1 w-full lg:w-auto">
          <div className="flex flex-col lg:flex-row lg:items-start gap-4">
            
            {/* Class Details */}
            <div className="flex-1">
              <h3 className="font-[800] text-[18px] lg:text-[20px] leading-[22px] lg:leading-[25.2px] text-[#183864] mb-4">
                {item?.name}
              </h3>
              
              {/* Class Meta Information */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-6">
                <div className="flex items-center text-[#9A9EA6] text-[14px] font-[500]">
                  <svg className="w-4 h-4 mr-2 text-[#B02526]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4M3 8h18v2H3V8zm0 2h18v10a2 2 0 01-2 2H5a2 2 0 01-2-2V10z" />
                  </svg>
                  <span className="font-[600] text-[#183864] mr-1">Date:</span> 
                  {new Date(item?.startDate).toLocaleDateString()}
                </div>
                <div className="flex items-center text-[#9A9EA6] text-[14px] font-[500]">
                  <svg className="w-4 h-4 mr-2 text-[#B02526]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span className="font-[600] text-[#183864] mr-1">Location:</span> 
                  {item?.campus}
                </div>
                <div className="flex items-center text-[#9A9EA6] text-[14px] font-[500]">
                  <svg className="w-4 h-4 mr-2 text-[#B02526]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="font-[600] text-[#183864] mr-1">Time:</span> 
                  {item?.timing}
                </div>
              </div>
              
              {/* Quantity Controls */}
              <div className='flex flex-col sm:flex-row gap-4 items-start sm:items-center'>
                {/* Desktop Quantity Controls */}
                <div className="hidden sm:flex items-center bg-white w-[140px] h-[52px] p-3 rounded-[12px] border-2 border-gray-200 hover:border-[#B02526]/30 transition-colors duration-200 shadow-sm">
                  <button 
                    className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-red-50 hover:text-[#B02526] transition-all duration-200 cursor-pointer group" 
                    onClick={() => decreaseNoSeats(item?.id, item?.seats)}
                  >
                    <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.03711 1H12.7038" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <div className="font-[700] text-[16px] leading-[26px] text-[#183864] min-w-[20px] text-center flex-1">
                    {item?.seats}
                  </div>
                  <button 
                    className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-green-50 hover:text-green-600 transition-all duration-200 cursor-pointer group" 
                    onClick={() => increaseNoSeat(item?.id, item?.seats)}
                  >
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M10.4689 4.16669C10.4689 3.9078 10.259 3.69794 10.0001 3.69794C9.74124 3.69794 9.53137 3.9078 9.53137 4.16669V9.53126H4.16699C3.90811 9.53126 3.69824 9.74112 3.69824 10C3.69824 10.2589 3.90811 10.4688 4.16699 10.4688H9.53137V15.8334C9.53137 16.0922 9.74124 16.3021 10.0001 16.3021C10.259 16.3021 10.4689 16.0922 10.4689 15.8334V10.4688H15.8337C16.0925 10.4688 16.3024 10.2589 16.3024 10C16.3024 9.74112 16.0925 9.53126 15.8337 9.53126H10.4689V4.16669Z" fill="currentColor"/>
                    </svg>
                  </button>
                </div>

                {/* Mobile Quantity Controls */}
                <div className="flex sm:hidden items-center bg-white w-[120px] h-[44px] p-2 rounded-[10px] border-2 border-gray-200 hover:border-[#B02526]/30 transition-colors duration-200">
                  <button 
                    className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-red-50 hover:text-[#B02526] transition-all duration-200 cursor-pointer" 
                    onClick={() => decreaseNoSeats(item?.id, item?.seats)}
                  >
                    <svg width="12" height="12" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.15625 6.52734H9.65141" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <div className="font-[700] text-[14px] leading-[16px] text-[#183864] min-w-[16px] text-center flex-1">
                    {item?.seats}
                  </div>
                  <button 
                    className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-green-50 hover:text-green-600 transition-all duration-200 cursor-pointer" 
                    onClick={() => increaseNoSeat(item?.id, item?.seats)}
                  >
                    <svg width="12" height="12" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M6.4924 3.2805C6.4924 3.13637 6.37556 3.01953 6.23143 3.01953C6.0873 3.01953 5.97046 3.13637 5.97046 3.2805V6.267H2.98362C2.83949 6.267 2.72266 6.38384 2.72266 6.52797C2.72266 6.67209 2.83949 6.78893 2.98362 6.78893H5.97046V9.77566C5.97046 9.91979 6.0873 10.0366 6.23143 10.0366C6.37556 10.0366 6.4924 9.91979 6.4924 9.77566V6.78893H9.47879C9.62291 6.78893 9.73975 6.67209 9.73975 6.52797C9.73975 6.38384 9.62291 6.267 9.47879 6.267H6.4924V3.2805Z" fill="currentColor"/>
                    </svg>
                  </button>
                </div>

                <div className="text-[14px] text-[#9A9EA6] sm:hidden bg-gray-50 px-3 py-2 rounded-lg">
                  <span className="font-[600] text-[#183864]">Seats:</span> {item?.seats}
                </div>
              </div>

              {/* Mobile Price */}
              <div className="flex items-center gap-2 mt-4 lg:hidden bg-gray-50 p-3 rounded-lg">
                <div className="text-[14px] text-[#9A9EA6] leading-[18px] font-[500]">Total:</div>
                <div className="font-[700] text-[16px] leading-[18px] text-[#B02526]">
                  ${(item?.price * item?.seats).toFixed(2)} CAD
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right side - Price and Remove */}
        <div className="flex flex-row lg:flex-col items-center justify-between lg:justify-center gap-4 w-full lg:w-auto">
          {/* Desktop Price */}
          <div className="hidden lg:flex items-center mb-4">
            <div className="font-[700] text-[24px] leading-[28px] text-[#B02526] text-center">
              ${(item?.price * item?.seats).toFixed(2)} CAD
            </div>
          </div>

          {/* Remove Button */}
          <button
            className="flex items-center justify-center w-12 h-12 rounded-full bg-red-50 hover:bg-red-100 border-2 border-red-200 hover:border-red-300 transition-all duration-200 group shadow-sm hover:shadow-md"
            onClick={() => handleRemoveFromCart(item?.id)}
            title="Remove from cart"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z" fill="#B02526" className="group-hover:fill-red-700 transition-colors duration-200"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}

export default CartItems
